/* eslint-disable eol-last */
/* eslint-disable indent */
import Vue from 'vue'
import Router from 'vue-router'
import PcIndex from '@/components/pc_index'
import MIndex from '@/components/m_index'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '',
            redirect: '/pc_index'
        },
        {
            path: '/pc_index', // pc端首页
            name: PcIndex,
            component: PcIndex
        },
        {
            path: '/m_index', // 手机端首页
            name: MIndex,
            component: MIndex
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js